import { groupAttachedPages } from './lotoAttachmentGroups'
import type { LotoPageDetails } from './lotoPageLookups'
import type { LotoAttachment, LotoIsolationPoint } from './lotoReportSchemas'

export type LotoDrawingLabel = {
  drawing: string | undefined
  pageNumbers: number[]
}

export type LotoDrawingsStatus = 'loading' | 'ready' | 'failed'

export const LOTO_COVERAGE_VISIBLE_ITEMS = 2

export function lotoPointTags(points: LotoIsolationPoint[]): string[] {
  return points.map(({ tag }) => tag.trim())
}

export function lotoDrawingLabels(
  attachments: LotoAttachment[],
  details: LotoPageDetails | undefined
): LotoDrawingLabel[] {
  return groupAttachedPages(attachments, details).map(
    ({ number, title, pages }) => ({
      drawing: number ?? title,
      pageNumbers: pages.flatMap(({ target }) =>
        target ? [target.pageNumber] : []
      ),
    })
  )
}

export function lotoDrawingsStatus({
  hasAttachments,
  hasDetails,
  isLoading,
  failed,
}: {
  hasAttachments: boolean
  hasDetails: boolean
  isLoading: boolean
  failed: boolean
}): LotoDrawingsStatus {
  if (!hasAttachments) return 'ready'
  if (failed && !hasDetails) return 'failed'
  if (isLoading || !hasDetails) return 'loading'
  return 'ready'
}

export function splitCoverage<T>(
  items: T[],
  visible = LOTO_COVERAGE_VISIBLE_ITEMS
): { shown: T[]; hiddenCount: number } {
  return {
    shown: items.slice(0, visible),
    hiddenCount: Math.max(items.length - visible, 0),
  }
}
